import { createAction } from '@mendeley-internal/lib-js-redux-actions';

export const setViewport = createAction('SET_VIEWPORT');



// WEBPACK FOOTER //
// ./src/universal/ui/actions/viewport.js